export const legend = [
  {
    title: 'High Risk Site',
    status: 'circle_high',
  },
];
